import React from 'react';
import './Chapters.scss';

function Chapter1() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        Modern cities are marvels of human engineering, with the tallest skyscrapers, the most
        dazzling museums and restaurants, the biggest stadiums, and the fastest transit systems all
        depending on one thing to make them successful: infrastructure.
      </p>
      <p className="chapter__paragraph">
        For a city, physical infrastructure means energy, water, roads, and sanitation systems.
        Everything in a city stands on that solid foundation.
      </p>
    </section>
  );
}

export default Chapter1;
